import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import OtaRefreshStage from './OtaRefreshStage';
import { InternalError, RetryError } from './PanelContent';
import {
  WarningMessageStyled as WarningMessage,
  DangerIconStyled as DangerIcon,
} from './PanelContent/styles/PanelContentStyled';
import Loading from '../../../General/Loading';
import HomeService from '../../../../services/Home';
import InvoicesService from '../../../../services/Invoices';
import NetworkIssuesService from '../../../../services/NetworkIssues';
import useSegment from '../../../../hooks/useSegment';
import { GoogleTagManager } from '../../../../helpers';

const DataBalanceWarning = (
  <WarningMessage>
    <DangerIcon />
    <p>
      Es posible que no puedas navegar porque consumiste todos tus datos, una
      vez tengas conexión realiza una{' '}
      <Link to="/marketplace/categorias">compra de bolsa</Link>
    </p>
  </WarningMessage>
);

const OverdueWarning = (
  <WarningMessage>
    <DangerIcon />
    <p>
      Es posible que no puedas navegar porque tu boleta de telefonía móvil está
      vencida
      <br />
      <Link to="/mis-boletas">Ver mis boletas</Link>
    </p>
  </WarningMessage>
);

const OtaRefreshPanel = ({ closePanel }) => {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState(0);
  const [available, setAvailable] = useState(true);
  const [warning, setWarning] = useState(null);
  const { isPrepaid } = useSegment();

  const resolveWarning = () => {
    if (isPrepaid) {
      return HomeService.getBalance().then(
        ([{ otherData, promotionalData }]) => {
          const dataBalance = [...otherData, ...promotionalData].reduce(
            (prev, { balance = 0 }) => prev + Number(balance),
            0
          );
          return dataBalance === 0 ? DataBalanceWarning : null;
        }
      );
    }
    return InvoicesService.getInvoiceStatus().then(([{ debtStatus }]) => {
      return debtStatus === 'not_paid' ? OverdueWarning : null;
    });
  };

  const checkAvailability = () => {
    if (!loading) setLoading(true);
    Promise.all([
      NetworkIssuesService.getRefreshAvailability(),
      resolveWarning(),
    ])
      .then(([[availabilityResponse], warningResponse]) => {
        setAvailable(availabilityResponse.available);
        setWarning(warningResponse);
        setLoading(false);
        setErrors(0);
      })
      .catch(() => {
        GoogleTagManager.pushToDataLayer({
          event: 'pagina-virtual',
          page: '/ayuda/problemas-red/modal-reinicio-red/error-factibilidad',
          pageName: 'Problemas de Red - Reinicio de red - Error factibilidad',
        });
        setErrors(prev => prev + 1);
        setLoading(false);
      });
  };

  useEffect(() => {
    checkAvailability();
  }, []);

  if (loading) return <Loading />;
  if (errors > 2) return <InternalError />;
  if (errors)
    return <RetryError retry={checkAvailability} close={closePanel} />;
  return (
    <OtaRefreshStage
      available={available}
      warning={warning}
      closePanel={closePanel}
    />
  );
};

OtaRefreshPanel.propTypes = {
  closePanel: PropTypes.func.isRequired,
};

export default OtaRefreshPanel;
